import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {Licenses} from '../../interfaces/core/licenses';
import {LicensesFactory} from '../../factories/core/lisenses-factor';


@Injectable({
  providedIn: 'root'
})
export class LicensesService {

  private _licenses: Licenses = LicensesFactory.new();

  constructor(private storageService: StorageService) {

  }

  public async setLicenses(licenses: Licenses): Promise<void> {
    await this.storageService.setItem('licenses', licenses);
    this._licenses = licenses;
  }

  public getLicenses(): Licenses {
    return this._licenses;
  }

  public async init(): Promise<void> {
    const licenses = await this.storageService.getItem('licenses');
    if(licenses) {
      this._licenses = LicensesFactory.fromObject(licenses);
    }
  }
}
